export default function ImageHtml({src,errSrc='/assets/img/logo.png',className='',id=null}){
    const imageErr = (e) => {
      console.error("imageErr",e.target.src)
        e.target.src = errSrc;
    };

    return <img src={src} onError={imageErr} className={className} id={id} />
}